export default __webpack_public_path__ + "static/media/lifeleech5.de0f2f60.png";